import type { ReactElement } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Combobox } from "@similarweb/ui-components";

import { LocationGroupedRegionSection } from "./LocationGroupedRegionSection";
import { StyledHeightComboboxContent } from "./styles";
import type { VisibleRegionGroup } from "./types";

export type LocationDropdownOptionsBodyProps = {
    visibleGroups: readonly VisibleRegionGroup[];
    selectedCodes: ReadonlySet<number>;
    dataAutomation: string;
    searchActive: boolean;
    isRegionExpanded: (regionName: string) => boolean;
    onChange: (codes: readonly number[]) => void;
    toggleExpanded: (regionName: string) => void;
};

export const LocationDropdownOptionsBody = ({
    visibleGroups,
    selectedCodes,
    dataAutomation,
    searchActive,
    isRegionExpanded,
    onChange,
    toggleExpanded,
}: LocationDropdownOptionsBodyProps): ReactElement => {
    const { translate } = useTranslate();

    return (
        <StyledHeightComboboxContent
            emptyState={<Combobox.OptionLabel>{translate("dropdown.no.results")}</Combobox.OptionLabel>}
        >
            {visibleGroups.map(({ group, filteredCountries, filteredSubGroups }) => (
                <LocationGroupedRegionSection
                    key={group.region.name}
                    group={group}
                    filteredCountries={filteredCountries}
                    filteredSubGroups={filteredSubGroups}
                    selectedCodes={selectedCodes}
                    dataAutomation={dataAutomation}
                    searchActive={searchActive}
                    isRegionExpanded={isRegionExpanded}
                    onChange={onChange}
                    toggleExpanded={toggleExpanded}
                />
            ))}
        </StyledHeightComboboxContent>
    );
};
